export default __webpack_public_path__ + "static/media/israel-hayom.c7240dd1.svg";